var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9796 4.22449C30.9796 1.89137 32.871 0 35.2041 0C37.5372 0 39.4286 1.89137 39.4286 4.22449V64.7755C39.4286 67.1086 37.5372 69 35.2041 69C32.871 69 30.9796 67.1086 30.9796 64.7755V4.22449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7755 30.9796C67.1086 30.9796 69 32.871 69 35.2041C69 37.5372 67.1086 39.4286 64.7755 39.4286L4.22449 39.4286C1.89137 39.4286 -1.01984e-07 37.5372 0 35.2041C1.01984e-07 32.871 1.89137 30.9796 4.22449 30.9796L64.7755 30.9796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.d682559bef005c68548f7eb39ba4ebc1.svg";
export { ForwardRef as ReactComponent };